/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon24Regular = forwardRef('ArrowShapeTriangleAUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.437 18.75c-1.386 0-2.222-1.535-1.47-2.7L10.53 5.893a1.75 1.75 0 0 1 2.94 0l6.563 10.157c.753 1.165-.083 2.7-1.47 2.7H5.438Zm-.21-1.886a.25.25 0 0 0 .21.386h13.127a.25.25 0 0 0 .21-.386L12.21 6.707a.25.25 0 0 0-.42 0L5.227 16.864Z" })));
});
